import { PayloadAction } from '@reduxjs/toolkit';
import { localStorageEnum } from 'types';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { hiikoEnvSaga } from './saga';
import { HiikoEnvState, ICreateEnvPayload, IEnv } from './types';

export const initialState: HiikoEnvState = {
  envs: [],
  selectedEnvId: null,
  initLoading: false,
  createEnvLoading: false,
  isCreateEnvFormVisible: false,
};

const slice = createSlice({
  name: 'hiikoEnv',
  initialState,
  reducers: {
    initLoadEnvs(state, action: PayloadAction) {
      state.initLoading = true;
    },
    setInitEnvsLoading(state, action: PayloadAction<boolean>) {
      state.initLoading = action.payload;
    },

    setEnvs(state, action: PayloadAction<IEnv[]>) {
      state.envs = action.payload;
    },

    setSelectedEnvId(state, action: PayloadAction<number>) {
      const envId = action.payload;

      localStorage.setItem(localStorageEnum.envId, String(envId));

      state.selectedEnvId = envId;
    },
    createEnv(state, action: PayloadAction<ICreateEnvPayload>) {
      state.createEnvLoading = true;
    },

    setCreateEnvLoading(state, action: PayloadAction<boolean>) {
      state.createEnvLoading = action.payload;
    },
    setIsCreateEnvFormVisible(state, action: PayloadAction<boolean>) {
      state.isCreateEnvFormVisible = action.payload;
    },
    archiveEnv(state, action: PayloadAction<number>) {},
  },
});

export const { actions: hiikoEnvActions } = slice;

export const useHiikoEnvSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: hiikoEnvSaga });
  return { actions: slice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useHiikoEnvSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
